module.exports = __webpack_public_path__ + "static/index/img/baikal-118.cb3a89cd.jpg";